import React, { useEffect, useState } from 'react'
import { Table } from 'antd'
import fetchAPI from '../../../../lib/utils/fetch-api'
import dayjs from 'dayjs'
import { DarkLink } from '../../../components/dark-link'
import { formatCurrency } from '../../../components/v2/product-detail/model/services/formatCurrency'

const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    render: (id: string | number) => <DarkLink to={`/order/${id}`}>{id}</DarkLink>,
  },
  {
    title: 'Стадия',
    dataIndex: 'stage',
    key: 'stage',
  },
  {
    title: 'Офис',
    dataIndex: 'office',
    key: 'office',
  },
  {
    title: 'Дата создания',
    dataIndex: 'created_at',
    key: 'created_at',
    render: (text: string) => dayjs(text).format('DD.MM.YYYY HH:mm'),
  },
  {
    title: 'Сумма заказа',
    dataIndex: 'sum',
    key: 'sum',
    render: (value: number) => formatCurrency(value),
  },
  {
    title: 'Оплата',
    dataIndex: 'payments',
    key: 'payments',
    render: (value: number) => formatCurrency(value),
  },
  {
    title: 'Адрес объекта',
    dataIndex: 'address',
    key: 'address',
  },
  {
    title: 'Номер производственного заказа',
    dataIndex: 'production_number',
    key: 'production_number',
  },
]

interface IOrderData {
  id: number
  stage: string
  created_at: string
  sum: number
  payments: number
  address: string
  production_number: string
}

function TabGeneral({ clientId }){
  const [data, setData] = useState<IOrderData[]>([])

  useEffect(() => {
    (async () => {
      const result = await fetchAPI(`/api/order-list?customer=${clientId}`)
      setData(result as IOrderData[])
    })()
  }, [clientId])

  const totalCaseSum = data.reduce(
    (sum, item) => sum + item.sum,
    0,
  )

  const totalPaymentsSum = data.reduce(
    (sum, item) => sum + +item.payments,
    0,
  )

  return (
    <>
      Сумма всех заказов: <b>{formatCurrency(totalCaseSum)}</b> руб.<br/>
      Сумма всех оплат: <b>{formatCurrency(totalPaymentsSum)}</b> руб.<br/>
      <Table
        style={{ marginTop: '20px' }}
        dataSource={data}
        columns={columns}
        pagination={false}
        rowKey='id'
      />
    </>
  )
}

export default TabGeneral
